import { toasterMsg } from '../../../Components/Toaster/Toaster';
import type from './CompanyRightsTypes.type';
import * as AuthService from '../../../services/auth.service';
import { defaultCompanyRights } from '../../../Components/helper';

const somethingWentWrong = 'Something went wrong';

const fetchCompanyRights = () => async (dispatch) => {
  try {
    const res = await AuthService.fetchCompanyRights();
    if (res?.code === 200 && res.data) {
      const updatedRights = { ...defaultCompanyRights };
      res?.data?.rights?.forEach((right) => (updatedRights[right] = true));
      await dispatch({
        type: type.FETCH_COMPANY_RIGHTS,
        payload: updatedRights,
      });
      await dispatch({
        type: type.FETCH_COMPANY_RIGHTS_EXCLUDES,
        payload: res?.data?.excludeModules,
      });
      return true;
    }
    return true;
  } catch (err) {
    console.log('error...', err);
    toasterMsg(somethingWentWrong, 'danger');
  }
};
export { fetchCompanyRights };
